import React, { useState, useEffect } from "react";

import AWS from "aws-sdk";
import { colors } from "../../../../../../../themes/Colors";
import { BaseButtons } from "../../../../../../common-components";

const CatalogueListItem = ({
  category,
  productName,
  price,
  createdBy,
  dateCreated,
  status,
  onViewClick,
  imageUrl,
}) => {
  const [imagelink, setImageLink] = useState("");
  const getUplaodImage = async () => {
    const S3_BUCKET = process.env.REACT_APP_BUCKET;
    const apiKey = process.env.REACT_APP_AWS_ACCESS_KEY_ID;
    const secrectapiKey = process.env.REACT_APP_AWS_SECRET_KEY_ID;
    AWS.config.update({
      accessKeyId: apiKey,
      secretAccessKey: secrectapiKey,
    });
    const s3 = new AWS.S3({
      params: { Bucket: S3_BUCKET },
      region: process.env.REACT_APP_REGION,
      signatureVersion: "v4",
    });

    const params = {
      Bucket: S3_BUCKET,
      Key: imageUrl,
    };

    var promise = s3.getSignedUrlPromise("getObject", params);
    // return promise;
    promise.then(
      function (url) {
        if (url) {
          setImageLink(url);
        }
        return url;
      },
      function (err) {
        console.log(err);
      }
    );
  };
  useEffect(() => {
    getUplaodImage();
  }, []);
  return (
    <div
      style={{
        width: "100%",
        minHeight: 40,
        paddintop: 5,
        // paddingBottom: 5,
        backgroundColor: colors.white,
        display: "flex",
        alignItems: "center",
        borderBottomStyle: "solid",
        borderBottomWidth: 1,
        borderColor: "#00000030",
      }}
    >
      <div
        style={{
          minWidth: 40,
          maxWidth: 40,
          overflow: "hidden",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 40,
        }}
      >
        <img alt="product" src={imagelink} style={{ height: 40, width: 40 }} />
      </div>
      <div
        style={{
          fontWeight: "bold",
          fontSize: 10,
          //   color: colors.white,
          flex: 0.2,
        }}
      >
        <div style={{ marginLeft: 10 }}> {productName}</div>
      </div>
      <div
        style={{
          fontWeight: "bold",
          fontSize: 10,
          //   color: colors.white,
          flex: 0.2,
        }}
      >
        {category}
      </div>
      <div
        style={{
          fontWeight: "bold",
          fontSize: 10,
          //   color: colors.white,
          flex: 0.2,
          overflow: "hidden",
        }}
      >
        <div style={{ width: "85%", overflow: "hidden" }}>{price}</div>
      </div>
      <div
        style={{
          fontWeight: "bold",
          fontSize: 10,
          //   color: colors.white,
          flex: 0.2,
        }}
      >
        {createdBy}
      </div>
      <div
        style={{
          fontWeight: "bold",
          fontSize: 10,
          //   color: colors.white,
          flex: 0.15,
        }}
      >
        {dateCreated}
      </div>
      <div
        style={{
          fontWeight: "bold",
          fontSize: 10,
          //   color: colors.white,
          flex: 0.1,
          //   display: "flex",
          //   justifyContent: "center",
          //   alignItems: "center",
        }}
      >
        {status}
      </div>
      <div
        style={{
          fontWeight: "bold",
          fontSize: 10,
          //   color: colors.white,
          flex: 0.15,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <BaseButtons
          label={"VIEW"}
          borderRadius={4}
          backgroundColor={colors.greenLight}
          height={30}
          width={"95%"}
          onClick={onViewClick}
        />
      </div>
    </div>
  );
};

export default CatalogueListItem;
